import request from "../../Frontends/Common/utils/request/requestMain";
const _ = require("lodash");
const rootRoute = "/addressprogram/outlettype/";

export default class OutletTypeApi {
  constructor() {
    this.defaultModel = {
    };
  }
  async getOutletTypes(params) {
    return await request.post(`${rootRoute}getOutletTypes`, {
      filter: params,
      parameters: {},
    });
  }
  async getOutletType(id) {
    return await request.post(`${rootRoute}getOutletTypes`, {
      filter: `$filter=Id eq ${id}`,
      parameters: {},
    });
  }
  async createOutletType(model) {
    const data = [_.merge(_.cloneDeep(this.defaultModel), model)];
    return await request.post(`${rootRoute}createOutletType`, { data });
  }
  async deleteOutletType(model) {
    const data = [model];
    return await request.post(`${rootRoute}deleteOutletType`, { data });
  }
  async editOutletType(model) {
    const data = [_.merge(_.cloneDeep(this.defaultModel), model)];
    return await request.post(`${rootRoute}updateOutletType`, { data });
  }
  async import(gfid) {
    return await request.post(`${rootRoute}importOutletType`, {
      gfid: gfid
    });
  }
  async getImportScaffold() {
    return await request.post(`${rootRoute}getOutletTypeimporttemplate`, null, {responseType: 'blob'});
  }
  async export(filter, format) {
    return await request.post(`${rootRoute}exportOutletType`, {
      filter: filter,
      format: format
    });
  }
}
